import { pluralizeToString } from 'lib/string/pluralize'

export function formatTourV2SnapshotRoom(room: App.Tours.V2OfferSnapshotRoom) {
  const {
    adultCount,
    childCount,
  } = room

  return `${adultCount ? pluralizeToString('adult', adultCount) : ''}${childCount ? `, ${pluralizeToString('child', childCount)}` : ''}`
}
